var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [_vm._v("계정")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleCloseModal },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-account" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://blogpfthumb-phinf.pstatic.net/MjAxOTA2MThfMjE2/MDAxNTYwODM2ODQ5MDk5.QteT5YL-OesHK0KxOdLg_5sTkIOvAqT10uVjT8rdNrsg.IIvp-gexFczdgl3bbJL4riqyDoTLAJkXOSSbfJEB6JUg.PNG.blogpeople/%255BTeamBlog%255DProfile%25402x.png?type=s1",
                              alt: "Naver blog",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Gmail connect")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("div", { staticClass: "account-select" }, [
                        _c("dl", { staticClass: "go-block-between" }, [
                          _c("dt", [
                            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Trending")]),
                          ]),
                          _vm._v(" "),
                          _c("dd", [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-switch" },
                              [
                                _c("input", {
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customSwitch1",
                                  },
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "customSwitch1" },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleShowAddAccount.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                            _vm._v(
                              "\n                  다른 계정 등록\n                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }